(function() {
    'use strict';

    angular
        .module('receiptApp')
        .controller('ReceiptCancelD61D70DialogController', ReceiptCancelD61D70DialogController);

    ReceiptCancelD61D70DialogController.$inject = ['$scope', '$uibModalInstance', 'lstCancelD61D70Reason', 'receipt', 'ReceiptService', '$location'];

    function ReceiptCancelD61D70DialogController ($scope, $uibModalInstance, lstCancelD61D70Reason, receipt, ReceiptService, $location) {
    	var cancelD61d70DlgCtr = this;
    	cancelD61d70DlgCtr.lstCancelD61D70Reason = lstCancelD61D70Reason;
    	cancelD61d70DlgCtr.cancel= cancel;
    	cancelD61d70DlgCtr.cancelReason = cancelReason;
    	cancelD61d70DlgCtr.receipt = receipt;
    	cancelD61d70DlgCtr.errorMessage = null;
    	
    	  function cancelReason() {
    		$scope.loading = true;
    		cancelD61d70DlgCtr.receipt.cancelReasonCode = cancelD61d70DlgCtr.cancelReasonCode;
       		 ReceiptService.save({uri:"do-cancel-approve"},cancelD61d70DlgCtr.receipt, function (result){
       			 $uibModalInstance.close(result);
       			 $scope.loading = false;
       		 }, function (error){
       			 $scope.loading = false;
       		 });  
    		 
    	    
    	  };

    	  function cancel() {
    	    $uibModalInstance.dismiss('cancel');
    	  };
    }
})();
